import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Stack } from '@mui/material';
import { useReactFlow } from '@xyflow/react';
import { ActionIcons } from '../../../../Iconography';
export const Buttons = ({ loading, isSmallView }) => {
    const { fitView } = useReactFlow();
    return (_jsx(Stack, { direction: "row", gap: 1, children: _jsx(Button, { variant: "contained", disabled: loading, startIcon: _jsx(ActionIcons.DoMagic, {}), onClick: () => fitView(fitViewOptions), children: !isSmallView ? 'Fit view' : 'Fit' }) }));
};
export const fitViewOptions = {
    maxZoom: 4,
    minZoom: 0.125,
    padding: 0.1,
    duration: 1000,
};
